module.exports = __webpack_public_path__ + "img/map_marker.b71e7fa9.svg";